define([], () => ({
  IMAGE_SHARER_UPDATE_SETTING: 'IMAGE_SHARER_UPDATE_SETTING',
  IMAGE_SHARER_RECEIVE_SHORTENER_SETTINGS: 'IMAGE_SHARER_RECEIVE_SHORTENER_SETTINGS',
  IMAGE_SHARER_RECEIVE_SETTINGS: 'IMAGE_SHARER_RECEIVE_SETTINGS',
  IMAGE_SHARER_RECEIVE_STATS: 'IMAGE_SHARER_RECEIVE_STATS',
}));
